import { useExperiments } from '@wix/fe-essentials-standalone';
import { ENABLE_MP_HEADER_APPLY_TO_MP_CTA } from '@utils/constants';

export const useHeaderApplyToMpCTA = () => {
  const { experiments } = useExperiments({ readOnly: true });
  const isApplyToMpCTAEnabled = experiments.enabled(
    ENABLE_MP_HEADER_APPLY_TO_MP_CTA,
  );

  return { isApplyToMpCTAEnabled };
};
